import React from 'react';
import Router from './Router';
import { styled } from '@mui/material';
import { Toaster } from 'react-hot-toast';

const ContainerDiv = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: '100%',
  width: '100%',
}));

export default function App() {

  return (
    <ContainerDiv>
      <Toaster />
      <Router />
    </ContainerDiv>
  );
}
